import { negate } from '@pogokid/util/lodash'
import { ProcessedEvent } from '../../types'
import { Fragment } from 'react'
import { bucketEventsWithinSteps } from '../../helpers/overlappingEventsWith'
import {
  useEventPositioning,
  useMinutesInCell,
} from '../../hooks/eventHooks'
import { SingleDayEvent } from './SingleDayEvent'
import { isBackgroundEvent } from '../../helpers/guards'
import { SingleDayBackgroundEvents } from './SingleDayBackgroundEvents.tsx'
import { useSchedulerPropsContext } from '../../context/schedulerContext.ts'

interface TodayEventsProps {
  todayEvents: ProcessedEvent[]
}

export const DayColumnEvents = ({
  todayEvents,
}: TodayEventsProps) => {
  const step = useMinutesInCell()
  const { selectedEventUids } = useSchedulerPropsContext()
  const { arrangeEvents, positionStartMinute } =
    useEventPositioning()

  const foregroundEvents = todayEvents.filter(
    negate(isBackgroundEvent)
  )
  const backgroundEvents = bucketEventsWithinSteps({
    events: todayEvents.filter(isBackgroundEvent),
    step,
  })

  const { arranged } = arrangeEvents(foregroundEvents)

  return (
    <Fragment>
      {Array.from(backgroundEvents.entries()).map(
        ([minute, result]) => {
          const { top, height } = positionStartMinute(
            minute,
            step
          )
          return (
            <SingleDayBackgroundEvents
              key={minute}
              events={result.events}
              top={top}
              height={height}
            />
          )
        }
      )}
      {[...arranged.values()].map((event) => {
        return (
          <SingleDayEvent
            key={event.uid}
            event={event.event}
            isSelected={selectedEventUids.includes(event.uid)}
            height={event.height}
            top={event.top}
            width={event.width}
            distanceFromEdge={event.left}
          />
        )
      })}
    </Fragment>
  )
}
